import { Outlet } from "react-router-dom";
import { ParentTopBar } from "../topbar/Topbar";
import { useState } from "react";

const ParentLayout = ({ parentType, type }) => {
  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  return (
    <div className="layout">
      <ParentTopBar
        toggleSidebar={toggleSidebar}
        parentType={parentType}
        type={type}
      />
      <Outlet context={{ parentType }} />
    </div>
  );
};

export default ParentLayout;
